import { useEffect, useMemo, useState } from 'react'
import { useDidMount } from './util/hooks'
import { getSearch, getSearchItem, setSearch, updateSearchItem } from './util/search'
import { packScenario, unpackScenario } from './logic/scenarios/serialization'
import { DefaultScenario } from './logic/scenarios/data'
import { Guide, PageHandle, packPageHandle, unpackPageHandle } from './logic/Guide'
import './scss/index.scss'
import Architecture from './logic/Architecture'
import UI from './components/UI'

const App = () => {
  const [scenario, setScenario] = useState(DefaultScenario)
  const [pageHandle, setPageHandle] = useState<PageHandle|undefined>(undefined)
  const [isPrint, setPrint] = useState(false)
  const [initWizard, setInitWizard] = useState(false)
  const [licenseID, setLicenseID] = useState<string|undefined>(undefined)

  useDidMount(() => 
  {
    const search = getSearch()
    
    // If "license" is present in the query string, turn it into a scenario
    const license = getSearchItem(search, 'license')
    if(license !== undefined)
    {
      const updatedScenario = { ...DefaultScenario, license }      
      setScenario(updatedScenario)     
      setInitWizard(true)
    }

    // If "licenseID" is present in the query string, keep it in state and the URL (in case bookmarks are used, we don't want to loose it)
    const initialLicenseID = getSearchItem(search, 'licenseID')
    if(initialLicenseID != undefined)
    {
      setLicenseID(initialLicenseID)
    }

    // If "scenario" and potentially "page" are in the query string, extract them into state
    const scenarioStr = getSearchItem(search, 'scenario')
    if(scenarioStr !== undefined)
    {
      const loadScenario = unpackScenario(scenarioStr)
      setScenario(loadScenario)

      const pageStr = getSearchItem(search, 'page')
      if(pageStr !== undefined)
      {
        const loadPage = unpackPageHandle(pageStr)
        setPageHandle(loadPage)
      }
    }
  })

  // Turn the scenario into an architecture and guide
  const architecture = useMemo(() => Architecture.Create(scenario), [scenario])
  const guide = useMemo(() => Guide.Create(scenario, architecture), [scenario, architecture])

  // Ensure the chosen page, actually exists for the given scenario
  const current = guide.validatePageHandle(pageHandle)
  if(current != pageHandle) {
    setPageHandle(current)
  }

  // When scenario+pageHandle change, update the search query
  useEffect(() => {
    let search = getSearch()
    search = updateSearchItem(search, 'license', undefined)
    search = updateSearchItem(search, 'scenario', packScenario(scenario))
    search = updateSearchItem(search, 'page', packPageHandle(pageHandle))
    setSearch(search)
  }, [scenario, pageHandle])
  
  return <>    
    {UI({ licenseID, isPrint, setPrint, scenario, architecture, navigate: setPageHandle, pageHandle: current, setScenario, initWizard })}    
  </>
}

export default App